import { Injectable, inject } from "@angular/core";
import { ReportDto } from "../../models/dtos/ReportDto";
import { BehaviorSubject, defaultIfEmpty, delay, map, Observable, Subject, switchMap, tap } from "rxjs";
import { ReportService } from "../../data/report.service";

@Injectable({
  providedIn: 'root'
})
export class ReportsListDataSource {
  private reportService = inject(ReportService);

  countSubject = new BehaviorSubject<number>(0);
  count$: Observable<number> = this.countSubject.asObservable();

  constructor() { }

  reportsSubject = new Subject<PagingRequest>();
  reports$: Observable<ReportDto[]> = this.reportsSubject.pipe(
    delay(0),
    switchMap((request) =>
      this.reportService.getReports(request.Page, request.PageSize, request.SortingField, request.SortingDirection).pipe(
        tap((res) => this.countSubject.next(res.Count)),
        map((res) => {
          const reports = res.Results;

          if (!reports || reports.length === 0) {
            return [];
          }

          const newestReport = reports.reduce((newest, report) => {
            return new Date(report.GeneratedDate) > new Date(newest.GeneratedDate) ? report : newest;
          }, reports[0]);

          reports.forEach(report => {
            report.IsNewest = report === newestReport;
          });

          return reports;
        }),
        defaultIfEmpty([])
      ),
    ),
  );
}

interface PagingRequest {
  Page: number;
  PageSize: number;
  SortingDirection: string;
  SortingField: string;
}
